import { ChangeDetectionStrategy, Component, computed, effect, input, signal } from '@angular/core';

import { StoreAuthorityStoreSnapshot } from '../../../../shared/models';

const COLLAPSED_ROWS = 6;

@Component({
  selector: 'app-store-authority-store-list',
  templateUrl: './store-authority-store-list.component.html',
  styleUrls: ['./store-authority-store-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreAuthorityStoreListComponent {
  readonly stores = input<StoreAuthorityStoreSnapshot[]>([]);
  readonly columns = input<number>(2);
  readonly searchTerm = input<string>('');
  readonly bordered = input<boolean>(true);

  readonly expanded = signal(false);

  readonly collapsedSize = computed(() => COLLAPSED_ROWS * this.columns());
  readonly visibleStores = computed(() =>
    this.expanded() ? this.stores() : this.stores().slice(0, this.collapsedSize())
  );
  readonly canExpand = computed(() => this.stores().length > this.collapsedSize());
  readonly hasSearchTerm = computed(() => Boolean(this.searchTerm() && this.searchTerm().trim()));

  constructor() {
    effect(
      () => {
        this.stores();
        this.expanded.set(false);
      },
      { allowSignalWrites: true }
    );
  }

  toggleExpand() {
    this.expanded.update(expanded => !expanded);
  }
}
